import { __awaiter, __generator } from "tslib";
import axios from 'axios';
import { extractHeadersFromAxiosResponse } from '../helpers/headers-helper';
import { httpDebugger } from './http.debugger';
import { retryHelper } from '../helpers/retry-helper';
export function getWithRetryAsync(instance, call, functionsConfig, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var retryStrategyOptions;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
                    return [4 /*yield*/, runWithRetryAsync({
                            retryAttempt: 0,
                            url: call.url,
                            retryStrategy: retryStrategyOptions,
                            functionsConfig: functionsConfig,
                            call: function (retryAttempt) { return __awaiter(_this, void 0, void 0, function () {
                                var axiosResponse, response;
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            httpDebugger.debugStartHttpRequest();
                                            return [4 /*yield*/, instance.get(call.url, {
                                                    headers: getHeadersJson((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : [], false),
                                                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                                                    cancelToken: (_b = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _b === void 0 ? void 0 : _b.token
                                                })];
                                        case 1:
                                            axiosResponse = _c.sent();
                                            response = {
                                                data: axiosResponse.data,
                                                rawResponse: axiosResponse,
                                                headers: extractHeadersFromAxiosResponse(axiosResponse),
                                                status: axiosResponse.status,
                                                retryStrategy: {
                                                    options: retryStrategyOptions,
                                                    retryAttempts: retryAttempt
                                                }
                                            };
                                            httpDebugger.debugSuccessHttpRequest();
                                            return [2 /*return*/, response];
                                    }
                                });
                            }); }
                        })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
export function postWithRetryAsync(instance, call, functionsConfig, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var retryStrategyOptions;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
                    return [4 /*yield*/, runWithRetryAsync({
                            retryAttempt: 0,
                            url: call.url,
                            retryStrategy: retryStrategyOptions,
                            functionsConfig: functionsConfig,
                            call: function (retryAttempt) { return __awaiter(_this, void 0, void 0, function () {
                                var axiosResponse, response;
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            httpDebugger.debugStartHttpRequest();
                                            return [4 /*yield*/, instance.post(call.url, call.body, {
                                                    headers: getHeadersJson((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : [], false),
                                                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                                                    // required for uploading large files
                                                    // https://github.com/axios/axios/issues/1362
                                                    maxContentLength: 'Infinity',
                                                    maxBodyLength: 'Infinity',
                                                    cancelToken: (_b = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _b === void 0 ? void 0 : _b.token
                                                })];
                                        case 1:
                                            axiosResponse = _c.sent();
                                            response = {
                                                data: axiosResponse.data,
                                                rawResponse: axiosResponse,
                                                headers: extractHeadersFromAxiosResponse(axiosResponse),
                                                status: axiosResponse.status,
                                                retryStrategy: {
                                                    options: retryStrategyOptions,
                                                    retryAttempts: retryAttempt
                                                }
                                            };
                                            httpDebugger.debugSuccessHttpRequest();
                                            return [2 /*return*/, response];
                                    }
                                });
                            }); }
                        })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
export function putWithRetryAsync(instance, call, functionsConfig, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var retryStrategyOptions;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
                    return [4 /*yield*/, runWithRetryAsync({
                            retryAttempt: 0,
                            url: call.url,
                            retryStrategy: retryStrategyOptions,
                            functionsConfig: functionsConfig,
                            call: function (retryAttempt) { return __awaiter(_this, void 0, void 0, function () {
                                var axiosResponse, response;
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            httpDebugger.debugStartHttpRequest();
                                            return [4 /*yield*/, instance.put(call.url, call.body, {
                                                    headers: getHeadersJson((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : [], false),
                                                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                                                    // required for uploading large files
                                                    // https://github.com/axios/axios/issues/1362
                                                    maxContentLength: 'Infinity',
                                                    maxBodyLength: 'Infinity',
                                                    cancelToken: (_b = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _b === void 0 ? void 0 : _b.token
                                                })];
                                        case 1:
                                            axiosResponse = _c.sent();
                                            response = {
                                                data: axiosResponse.data,
                                                rawResponse: axiosResponse,
                                                headers: extractHeadersFromAxiosResponse(axiosResponse),
                                                status: axiosResponse.status,
                                                retryStrategy: {
                                                    options: retryStrategyOptions,
                                                    retryAttempts: retryAttempt
                                                }
                                            };
                                            httpDebugger.debugSuccessHttpRequest();
                                            return [2 /*return*/, response];
                                    }
                                });
                            }); }
                        })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
export function patchWithRetryAsync(instance, call, functionsConfig, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var retryStrategyOptions;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
                    return [4 /*yield*/, runWithRetryAsync({
                            retryAttempt: 0,
                            url: call.url,
                            retryStrategy: retryStrategyOptions,
                            functionsConfig: functionsConfig,
                            call: function (retryAttempt) { return __awaiter(_this, void 0, void 0, function () {
                                var axiosResponse, response;
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            httpDebugger.debugStartHttpRequest();
                                            return [4 /*yield*/, instance.patch(call.url, call.body, {
                                                    headers: getHeadersJson((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : [], false),
                                                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                                                    // required for uploading large files
                                                    // https://github.com/axios/axios/issues/1362
                                                    maxContentLength: 'Infinity',
                                                    maxBodyLength: 'Infinity',
                                                    cancelToken: (_b = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _b === void 0 ? void 0 : _b.token
                                                })];
                                        case 1:
                                            axiosResponse = _c.sent();
                                            response = {
                                                data: axiosResponse.data,
                                                rawResponse: axiosResponse,
                                                headers: extractHeadersFromAxiosResponse(axiosResponse),
                                                status: axiosResponse.status,
                                                retryStrategy: {
                                                    options: retryStrategyOptions,
                                                    retryAttempts: retryAttempt
                                                }
                                            };
                                            httpDebugger.debugSuccessHttpRequest();
                                            return [2 /*return*/, response];
                                    }
                                });
                            }); }
                        })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
export function deletehWithRetryAsync(instance, call, functionsConfig, options) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var retryStrategyOptions;
        var _this = this;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    retryStrategyOptions = (_a = options === null || options === void 0 ? void 0 : options.retryStrategy) !== null && _a !== void 0 ? _a : retryHelper.defaultRetryStrategy;
                    return [4 /*yield*/, runWithRetryAsync({
                            retryAttempt: 0,
                            url: call.url,
                            retryStrategy: retryStrategyOptions,
                            functionsConfig: functionsConfig,
                            call: function (retryAttempt) { return __awaiter(_this, void 0, void 0, function () {
                                var axiosResponse, response;
                                var _a, _b;
                                return __generator(this, function (_c) {
                                    switch (_c.label) {
                                        case 0:
                                            httpDebugger.debugStartHttpRequest();
                                            return [4 /*yield*/, instance.delete(call.url, {
                                                    headers: getHeadersJson((_a = options === null || options === void 0 ? void 0 : options.headers) !== null && _a !== void 0 ? _a : [], false),
                                                    responseType: options === null || options === void 0 ? void 0 : options.responseType,
                                                    // required for uploading large files
                                                    // https://github.com/axios/axios/issues/1362
                                                    maxContentLength: 'Infinity',
                                                    maxBodyLength: 'Infinity',
                                                    cancelToken: (_b = options === null || options === void 0 ? void 0 : options.cancelToken) === null || _b === void 0 ? void 0 : _b.token
                                                })];
                                        case 1:
                                            axiosResponse = _c.sent();
                                            response = {
                                                data: axiosResponse.data,
                                                rawResponse: axiosResponse,
                                                headers: extractHeadersFromAxiosResponse(axiosResponse),
                                                status: axiosResponse.status,
                                                retryStrategy: {
                                                    options: retryStrategyOptions,
                                                    retryAttempts: retryAttempt
                                                }
                                            };
                                            httpDebugger.debugSuccessHttpRequest();
                                            return [2 /*return*/, response];
                                    }
                                });
                            }); }
                        })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
export function createCancelToken() {
    var canceler;
    var token = new axios.CancelToken(function (c) {
        // An executor function receives a cancel function as a parameter
        canceler = c;
    });
    return {
        cancel: function (cancelMessage) {
            return canceler("".concat(retryHelper.requestCancelledMessagePrefix, ": ").concat(cancelMessage !== null && cancelMessage !== void 0 ? cancelMessage : 'User cancel'));
        },
        token: token
    };
}
function runWithRetryAsync(data) {
    return __awaiter(this, void 0, void 0, function () {
        var error_1, retryResult_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 6]);
                    return [4 /*yield*/, data.call(data.retryAttempt)];
                case 1: return [2 /*return*/, _a.sent()];
                case 2:
                    error_1 = _a.sent();
                    retryResult_1 = retryHelper.getRetryErrorResult({
                        error: error_1,
                        retryAttempt: data.retryAttempt,
                        retryStrategy: data.retryStrategy
                    });
                    if (!retryResult_1.canRetry) return [3 /*break*/, 5];
                    httpDebugger.debugRetryHttpRequest();
                    // wait time before retrying
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, retryResult_1.retryInMs); })];
                case 3:
                    // wait time before retrying
                    _a.sent();
                    // retry request
                    console.warn("Retry attempt '".concat(data.retryAttempt + 1, "' from a maximum of '").concat(retryResult_1.maxRetries, "' retries. Request url: '").concat(data.url, "'"));
                    return [4 /*yield*/, runWithRetryAsync({
                            call: data.call,
                            retryStrategy: data.retryStrategy,
                            retryAttempt: data.retryAttempt + 1,
                            url: data.url,
                            functionsConfig: data.functionsConfig
                        })];
                case 4: return [2 /*return*/, _a.sent()];
                case 5:
                    if (data.functionsConfig.logErrorsToConsole) {
                        console.error("Executing '".concat(data.url, "' failed. Request was retried '").concat(data.retryAttempt, "' times. "), error_1);
                    }
                    throw error_1;
                case 6: return [2 /*return*/];
            }
        });
    });
}
function getHeadersJson(headers, addContentTypeHeader) {
    var headerJson = {};
    headers.forEach(function (header) {
        headerJson[header.header] = header.value;
    });
    if (addContentTypeHeader) {
        // add default content type header if not present
        var contentTypeHeader = headers.find(function (m) { return m.header.toLowerCase() === 'Content-Type'.toLowerCase(); });
        if (!contentTypeHeader) {
            headerJson['Content-Type'] = 'application/json';
        }
    }
    return headerJson;
}
//# sourceMappingURL=http.functions.js.map